import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { Logo } from "../components/Logo";
import { toast } from "sonner";


const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+(?:\.essteam|\.amalgus)@gmail\.com$/i;

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!EMAIL_PATTERN.test(email)) {
      setErr("Email must match pattern *.essteam/*.amalgus@gmail.com");
      return;
    }
    if (password.length < 6) {
      setErr("Password must be at least 6 characters");
      return;
    }
    setLoading(true);
    try {
      await register(name, email, password);
      toast.success("Account created");
      nav("/dashboard");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative overflow-hidden">
        <img
          src="https://customer-assets.emergentagent.com/job_hours-tracker-app-1/artifacts/6rlxr12z_Samanvay_8.jpg"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/35" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="ess-section-label mb-3" style={{ color: "#FFFFFF", opacity: 0.9 }}>REGISTRATION</div>
          <div className="text-3xl font-light leading-tight max-w-md">
            Restricted to <em>*.essteam@gmail.com</em> or <em>*.amalgus@gmail.com</em> accounts only.
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
          <Logo size={36} className="mb-12" />
          <h1 className="text-3xl font-semibold tracking-tight mb-2 text-[var(--ess-ink)]">Create account</h1>
          <p className="text-sm text-gray-500 mb-8">Only @essteam/@amalgus team members can register.</p>

          <label className="ess-section-label block mb-2">Full Name</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="w-full border border-gray-200 px-4 py-3 mb-5 outline-none focus:border-[var(--ess-ink)]"
            data-testid="register-name"
          />

          <label className="ess-section-label block mb-2">Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="name.essteam / name.amalgus@gmail.com"
            className="w-full border border-gray-200 px-4 py-3 mb-5 outline-none focus:border-[var(--ess-ink)]"
            data-testid="register-email"
          />

          <label className="ess-section-label block mb-2">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            className="w-full border border-gray-200 px-4 py-3 mb-6 outline-none focus:border-[var(--ess-ink)]"
            data-testid="register-password"
          />

          {err && <div className="mb-4 text-sm text-red-600" data-testid="register-error">{err}</div>}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[var(--ess-ink)] text-white py-3 text-sm font-medium tracking-wider uppercase hover:bg-[var(--ess-ink-soft)] disabled:opacity-60"
            data-testid="register-submit"
          >
            {loading ? "Creating..." : "Create account"}
          </button>

          <div className="mt-6 text-sm text-gray-500">
            Already have an account?{" "}
            <Link to="/login" className="text-[var(--ess-ink)] underline" data-testid="link-login">
              Sign in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
